import * as React from "react";
import { useGlobalStore } from "../../../contexts/StoreContext";
// import { getAdminActiveCases } from "../../../services/adminController";
import { Tabs, notification } from "antd";
// import { getCasePayload } from "../../../utils";
// import { keepPreviousData, useQuery } from "@tanstack/react-query";
// import { getAgentActiveCases, getAgentPendingCases } from "../../../services/agentController";
import { TableView } from "./TableView";

interface AdminTableProps {
  tableProps: any;
}

export const AgentTable: React.FC<AdminTableProps> = ({ tableProps }) => {
  const { state, dispatch } = useGlobalStore();
  const [api, contextHolder] = notification.useNotification();

  //const payload = getCasePayload(state);
  // const {
  //   data: activeCases,
  //   isPending: isActiveCasesPending,
  //   isRefetching: isActiveCasesRefetching,
  // } = useQuery({
  //   queryKey: ["agentActiveCases", payload],
  //   queryFn: () => getAgentActiveCases(payload),
  //   enabled: activeTabKey === "2",
  //   placeholderData: keepPreviousData,
  // });
  // const {
  //   data: pendingCases,
  //   isPending: isPendingCasesPending,
  //   isRefetching: isPendingCasesRefetching,
  // } = useQuery({
  //   queryKey: ["agentPendingCases", payload],
  //   queryFn: () => getAgentPendingCases(payload),
  //   enabled: activeTabKey === "1",
  //   placeholderData: keepPreviousData,
  // });

  const items = [
    {
      label: "Pending Case",
      key: "1",
      children: <TableView tableProps={tableProps} caseType="agentPending" />,
    },
    {
      label: "Active Cases",
      key: "2",
      children: <TableView tableProps={tableProps} caseType="agentActive" />,
    },
  ];

  const setActiveTabKey = (e: string) => {
    dispatch({ type: "SET_ACTIVE_TAB_KEY", payload: e });
  };

  return (
    <>
      {contextHolder}
      <Tabs items={items} onChange={setActiveTabKey} activeKey={state.activeTabKey} />
    </>
  );
};
